import * as focusTrap from 'focus-trap';
import { gsap } from 'gsap';
import { throttle } from "../helpers/utilityFunctions";

export default () => {
    'use strict'

    function init() {
        const body = document.querySelector('body');
        const menuToggleBtn = document.querySelector('#navbarSideCollapse') as HTMLElement;
        const offCanvasMenu = document.querySelector('#offcanvasMenu');
        const toggleMenuEvent = new Event('toggleCanvasMenu');
        const navbar = document.getElementById("mainNavigation");
        const header = document.getElementById('header')
        const myDropdowns = document.querySelectorAll('.dropdown')
        const searchDropdown = document.querySelector('[data-search-dropdown]');
        const searchBtn = document.querySelector('[data-search-button]');
        const searchBtnClose = document.querySelector('[data-search-close]');
        const searchForm = document.querySelector('[data-search-form]');
        const searchInput = searchForm?.querySelector('input');
        const searchFormMobile = document.querySelector('[data-search-form-mobile]');
        const modalBtns = offCanvasMenu?.querySelectorAll('[data-bs-toggle="modal"]') ?? [];
        const alert = header?.querySelector('.alert');
        let trap: focusTrap.FocusTrap;
        let windowWidth = window.innerWidth ?? 0;

        if (searchDropdown) {
            // Focus input on search drawer open
            searchBtn?.addEventListener('shown.bs.dropdown', () => {
                searchInput?.focus();
            })
            // Close search drawer
            searchBtnClose?.addEventListener('click', () => {
                window.bootstrap.Dropdown.getOrCreateInstance(searchDropdown).hide();
            });
        } else {
            searchBtn?.addEventListener('click', () => {
                searchInput?.focus();
            });
        }

        if (searchForm) {
            searchForm.addEventListener('submit', () => {
                searchForm.querySelector('button[type="submit"]')?.classList.add('loading');
            })
        }
        if (searchFormMobile) {
            searchFormMobile.addEventListener('submit', () => {
                searchFormMobile.querySelector('button[type="submit"]')?.classList.add('loading');
            })
        }

        // Toggle offCanvas Menu on menu btn click
        if (menuToggleBtn) {
            menuToggleBtn.addEventListener('click', (event) => {
                offCanvasMenu?.classList.toggle('open');
                const menuIsOpen = offCanvasMenu?.classList.contains('open');
                menuIsOpen ? header?.classList.add('menu-opened', 'mobile-nav-opened') : header?.classList.remove('menu-opened', 'mobile-nav-opened');
                menuIsOpen ? body?.classList.add('prevent-scroll') : body?.classList.remove('prevent-scroll');
                offCanvasMenu?.dispatchEvent(toggleMenuEvent)
            })
        }
        // Event Listener to trap focus in offCanvas Menu
        offCanvasMenu?.addEventListener('toggleCanvasMenu', () => {
            const menuIsOpen = offCanvasMenu.classList.contains('open');

            // Define nodes to be trap on first call of menu toggle
            const oneTrustBanner = document.querySelector('#onetrust-consent-sdk')
            let trapNodes = ['#mainNavigation'];
            if(!!oneTrustBanner) trapNodes.push('#onetrust-consent-sdk');
            if(!trap || menuIsOpen){
                trap = focusTrap.createFocusTrap(trapNodes);
            }
            setTimeout(() => {
                menuIsOpen ? trap.activate() : trap.deactivate();
            }, 150)
        })


        const closeMobileMenu = () => {
            offCanvasMenu?.classList.remove('open');
            header?.classList.remove('menu-opened', 'mobile-nav-opened');
            body?.classList.remove('prevent-scroll');
            trap?.deactivate()
        }

        // Event listener to remove trap focus on link that opens a modal
        // This fix the focus trap bug trying to set the trap inside another trap
        modalBtns.forEach(btn => {
            btn.addEventListener('click', () => {
                closeMobileMenu()
            })
        })

        let timeout: NodeJS.Timeout;
        let delay = 300;
        const mobileMenuBreakpoint = 992;

        // function to prevent incorrect prevent-scroll and trap problems
        const closeMobileElements = () => {
            const newWindowWidth = window.innerWidth;
            if (newWindowWidth >= mobileMenuBreakpoint && windowWidth < mobileMenuBreakpoint) {
                const menuIsOpen = offCanvasMenu?.classList.contains('open');
                if (menuIsOpen) {
                    menuToggleBtn?.click();
                }
                myDropdowns.forEach(dropdown => {
                    const bsDropdown = window.bootstrap.Dropdown.getOrCreateInstance(dropdown);
                    bsDropdown?.hide();
                })
                body?.classList.remove('prevent-scroll')
            }
            windowWidth = newWindowWidth;
        }

        // Update padding-top of first block depending on the height of the nav
        const updateBodyPadding = (animate = false) => {
            const blocks: any = document.querySelectorAll('.block-container .block');
            if (blocks.length) {
                const firstBlock = blocks[0];
                const height = header ? header.scrollHeight : 0;
                let spacing = window.innerWidth < 992 ? 16 : 32;

                if(!firstBlock.classList.contains('hero')){
                    spacing = window.innerWidth < 992 ? 32 : 48;
                }

                if(firstBlock.classList.contains('block--blood-draw-finder')
                    || firstBlock.classList.contains('block--provider-finder')){
                    spacing = window.innerWidth < 992 ? 16 : 0;
                }

                if(!body?.classList.contains('search-layout') && !firstBlock.classList.contains('page-references')) {
                    if (animate) {
                        gsap.to(firstBlock, {
                            paddingTop: `${height + spacing}px`,
                            duration: 0.3
                        })
                    } else {
                        firstBlock.style.paddingTop = `${height + spacing}px`;
                    }
                }
            }
        }

        if (alert) {
            const closeAlertBtn = alert.querySelector('[data-bs-dismiss]');
            closeAlertBtn?.addEventListener('click', () => {
                setTimeout(() => {
                    updateBodyPadding(true);
                }, 300)
            })
        }

        window.addEventListener('resize', (e) => {
            updateBodyPadding();
            clearTimeout(timeout);
            timeout = setTimeout(closeMobileElements, delay);
        });

        // Event Listener on sub-menu dropdowns open and close
        for (const dropdown of myDropdowns) {
            dropdown.addEventListener('show.bs.dropdown', event => {
                setTimeout(() => header?.classList.add('menu-opened'), 100);
            })

            dropdown.addEventListener('hide.bs.dropdown', event => {
                header?.classList.remove('menu-opened')
            })
        }

        // Scroll Listener for navbar animation
        let prevScrollPos = window.scrollY;
        const topBar = document.getElementById('topNavigationBar')
        const topBarHeight = topBar?.clientHeight || 0;
        const navbarHeight = navbar?.clientHeight;

        const onHeaderScroll = () => {
            let currentScrollPos = window.scrollY;
            const minScrollPos = navbarHeight ? navbarHeight / 3 : 0;
            if (currentScrollPos > prevScrollPos && currentScrollPos > minScrollPos) {
                if (!header?.classList.contains('menu-opened')) {
                    document.body.classList.remove('scroll-up');
                    document.body.classList.add('scroll-down');
                    if (searchDropdown) {
                        window.bootstrap.Dropdown.getOrCreateInstance(searchDropdown).hide();
                    }
                }
            } else {
                document.body.classList.remove('scroll-down');
                if (currentScrollPos > topBarHeight) {
                    document.body.classList.add('scroll-up');
                } else {
                    document.body.classList.remove('scroll-up');
                }
            }
            prevScrollPos = currentScrollPos;
        }
        if (header) {
            window.onscroll = () => {
                throttle(onHeaderScroll, 25)
            }
            setTimeout(() => updateBodyPadding(), 150);
        }
    }

    init();
}
